import { useMemo, useEffect, useState } from 'react';

const useAudio = (url) => {
  const audio = useMemo(() => new Audio(url), []);
  audio.volume = 0.5;
  const [playing, setPlaying] = useState(false);

  const toggle = (status) => setPlaying(status);

  useEffect(() => {
    if (playing) {
      const timer = window.setInterval(() => {
        audio.pause();
        audio.play();
      }, 1000);

      return () => {
        window.clearInterval(timer);
      };
    }
  }, [playing]);

  return [playing, toggle];
};

export default useAudio;
